export default __webpack_public_path__ + "static/logo dasco-cb52a687c929c5ad373c7281c6cac5f4.png";